/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
  AfterViewInit
} from '@angular/core';
import { debounceTime, distinctUntilChanged, fromEvent, map } from 'rxjs';
import { assetsConst } from 'src/app/core/const/assets.const';
@Component({
  selector: 'mega-store-vendor-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements AfterViewInit {
  @ViewChild('search')
    searchRef!: ElementRef;
  assetsConst = assetsConst;

  showCrossIcon = false;
  search = '';

  @Output() searchOutput: EventEmitter<any> = new EventEmitter();
  constructor() {
    // ToDo
  }

  ngAfterViewInit(): void {
    fromEvent(this.searchRef.nativeElement, 'keyup')
      .pipe(
        map((i: any) => i.target.value),
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe((res: any) => {
        if (res) {
          this.showCrossIcon = true;
          this.search = res;
          this.searchOutput.emit(res);
        } else {
          this.showCrossIcon = false;
          this.search = '';
          this.searchOutput.emit(res);
        }
      });
  }

  clearInputField(): void {
    this.searchRef.nativeElement.value = '';
    this.search = '';
    this.showCrossIcon = false;
    this.searchOutput.emit(null);
  }
}
